import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { primaryBlockDefaultStyles } from "../constants";

export interface HomepageBlock52Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HomepageBlock5_2 = forwardRef<
  HTMLDivElement,
  HomepageBlock52Props
>(({ content, styles, className, ...rest }, ref) => {
  const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles({
    styles,
    defaultStyles: primaryBlockDefaultStyles,
  });

  return (
    <BlockSection ref={ref} className={className} {...rest}>
      <BlockSection.Background style={backgroundStyles}>
        <BlockSection.Container>
          <BlockSection.Content
            style={{
              ...paddingStyles,
              ...marginStyles,
            }}
          >
            <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-items-center wb-gap-4 md:wb-grid lg:wb-grid-cols-3 md:wb-gap-[1.88rem] lg:wb-max-w-3xl lg:wb-mx-auto">
              {content}
            </BlockSection.NestedBlock>
          </BlockSection.Content>
        </BlockSection.Container>
      </BlockSection.Background>
    </BlockSection>
  );
});

HomepageBlock5_2.displayName = "HomepageBlock5_2";
